import React, { useEffect, useRef, useState } from 'react';

interface PowerStatementProps {
  text: string;
  variant?: 'dark' | 'accent' | 'minimal';
}

export const PowerStatement: React.FC<PowerStatementProps> = ({ text, variant = 'dark' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => { if (ref.current) observer.unobserve(ref.current); };
  }, []);

  const variants = {
    dark: 'bg-slate-900 border-l-4 border-orange-600 text-white',
    accent: 'bg-orange-600 text-white',
    minimal: 'bg-slate-50 border-l-4 border-slate-900 text-slate-900',
  };

  return (
    <div 
      ref={ref}
      className={`${variants[variant]} px-6 md:px-10 py-6 md:py-8 transition-all duration-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}
    >
      <p className="text-lg md:text-xl lg:text-2xl font-bold tracking-tight max-w-5xl mx-auto" style={{ fontFamily: "'Oswald', sans-serif" }}>
        "{text}"
      </p>
    </div>
  );
};
